import {Subject} from 'rxjs'
export const loaderSubject = new Subject();